module.exports = __webpack_public_path__ + "assets/smart-asset-rss.7e748f78.svg";